<div class="toast" [@fadeOutAnimation]="animationStatus" (click)="close()">
  <mfp-alert>
    {{message}}
    <ng-container *ngIf="duration === 0">
      <img class="toast__close" mfpLazyImage lazySrc='assets/icons/close.svg' alt="">
    </ng-container>
  </mfp-alert>
</div>
